import { render, staticRenderFns } from "./Headend.vue?vue&type=template&id=876d0e10&"
import script from "./Headend.vue?vue&type=script&lang=js&"
export * from "./Headend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports